import { SidebarNavItem } from './navigation.types';

/**
 * Konfigurasi Menu Navigasi Utama Aplikasi
 *
 * Format permission:
 * - Single: permission: 'user.read'
 * - Multiple (ANY): permission: ['user.read', 'user.create']
 * - Multiple (ALL): permission: ['user.read', 'user.create'], permissionStrategy: 'ALL'
 * - Tanpa permission (Bebas diakses): kosongkan properti permission
 */
export const defaultNavigation: SidebarNavItem[] = [
    {
        id: 'dashboard',
        label: 'Dashboard',
        icon: 'dashboard',
        route: '/dashboard',
    },
    {
        id: 'my-profile',
        label: 'Profil Saya',
        icon: 'account_circle',
        route: '/profile',
    },

    {
        id: 'user-management',
        label: 'User',
        icon: 'manage_accounts',
        route: '/users',
        permission: [
            'user.read',
            'users.read',
            'role.read',
            'roles.read',
            'permission.read',
            'permissions.read',
            'approval_rule.read',
            'approval_rules.read',
            'approval_rule.*',
            'approval_rules.*',
            'user.*',
            'role.*',
            'permission.*',
            '*',
        ],
        children: [
            {
                id: 'user-account',
                label: 'User Account',
                icon: 'people',
                route: '/users',
                permission: ['user.read', 'users.read', 'user.*', 'users.*'],
            },
            {
                id: 'user-verification',
                label: 'Verifikasi User',
                icon: 'how_to_reg',
                route: '/users/verification',
                permission: ['user.verify', 'user.read', 'user.*', '*'],
            },
            {
                id: 'roles-user',
                label: 'Roles User',
                icon: 'admin_panel_settings',
                route: '/users/roles',
                permission: ['role.read', 'roles.read', 'role.*', 'roles.*'],
            },
            {
                id: 'permission-role',
                label: 'Permssion Role',
                icon: 'vpn_key',
                route: '/users/permissions',
                permission: [
                    'permission.read',
                    'permissions.read',
                    'permission.*',
                    'permissions.*',
                ],
            },
            {
                id: 'approval-rules',
                label: 'Approval Rules',
                icon: 'rule',
                route: '/users/approval-rules',
                permission: [
                    'approval_rule.read',
                    'approval_rules.read',
                    'approval_rule.*',
                    'approval_rules.*',
                    'role.*',
                    '*',
                ],
            },
        ],
    },
    {
        id: 'master-data',
        label: 'Master Data',
        icon: 'storage',
        route: '/master-data',
        permission: [
            'division.read',
            'divisions.read',
            'division.*',
            'divisions.*',
            'position.read',
            'position.*',
            'company.read',
            'companies.read',
            'company.*',
            'companies.*',
            'user.read',
            'users.read',
            'user.*',
            'users.*',
            '*',
        ],
        children: [
            {
                id: 'organization-structure',
                label: 'Struktur Organisasi',
                icon: 'account_tree',
                route: '/master-data/organization-structure',
                permission: [
                    'division.read',
                    'divisions.read',
                    'division.*',
                    'divisions.*',
                    'company.read',
                    'companies.read',
                    'company.*',
                    'companies.*',
                    '*',
                ],
            },
            {
                id: 'employee',
                label: 'Karyawan',
                icon: 'badge',
                route: '/master-data/employees',
                permission: [
                    'user.read',
                    'users.read',
                    'user.*',
                    'users.*',
                    'division.read',
                    'divisions.read',
                    '*',
                ],
            },
            {
                id: 'division',
                label: 'Divisi',
                icon: 'domain',
                route: '/master-data/division',
                permission: [
                    'division.read',
                    'divisions.read',
                    'division.*',
                    'divisions.*',
                ],
            },
            {
                id: 'position',
                label: 'Jabatan & Posisi',
                icon: 'badge',
                route: '/master-data/position',
                permission: [
                    'position.read',
                    'position.*',
                    'division.read',
                    'divisions.read',
                    'user.read',
                    'users.read',
                    '*',
                ],
            },
            {
                id: 'company',
                label: 'Company',
                icon: 'business',
                route: '/master-data/company',
                permission: [
                    'company.read',
                    'companies.read',
                    'company.*',
                    'companies.*',
                ],
            },
            {
                id: 'leave-types',
                label: 'Jenis Cuti',
                icon: 'format_list_bulleted',
                route: '/master-data/leave-types',
                permission: [
                    'leave_type.read',
                    'leave_type.*',
                    'leave.read',
                    'leave.approve_hrd',
                    '*',
                ],
            },
        ],
    },
    {
        id: 'self-service',
        label: 'Portal Pengajuan',
        icon: 'assignment_ind',
        route: '/self-service',
        children: [
            {
                id: 'self-service-leaves',
                label: 'Cuti & Izin',
                icon: 'event_available',
                route: '/self-service/leaves',
            },
            {
                id: 'self-service-overtimes',
                label: 'Lembur (Overtime)',
                icon: 'schedule',
                route: '/self-service/overtimes',
            },
            {
                id: 'self-service-swap-day-offs',
                label: 'Tukar Hari Libur',
                icon: 'published_with_changes',
                route: '/self-service/swap-day-off',
            },
            {
                id: 'self-service-gohome-earlys',
                label: 'Pulang Cepat',
                icon: 'house',
                route: '/self-service/gohome-earlys',
            },
            {
                id: 'self-service-reimbursements',
                label: 'Reimbursement',
                icon: 'receipt_long',
                route: '/self-service/reimbursements',
            },
            {
                id: 'self-service-business-trips',
                label: 'Perjalanan Dinas',
                icon: 'flight_takeoff',
                route: '/self-service/business-trips',
            },
            {
                id: 'self-service-vehicle-bookings',
                label: 'Pinjam Kendaraan',
                icon: 'directions_car',
                route: '/self-service/vehicle-bookings',
            },
        ],
    },
    {
        id: 'approvals',
        label: 'Pusat Persetujuan',
        icon: 'verified',
        route: '/approvals',
        permission: [
            'leave.approve_read',
            'leave.approve_manager',
            'leave.approve_hrd',
            'leave.*',
            'overtime.approve_read',
            'overtime.approve_manager',
            'overtime.approve_hrd',
            'overtime.*',
            'swap_day_off.approve_read',
            'swap_day_off.approve_manager',
            'swap_day_off.approve_hrd',
            'swap_day_off.*',
            'gohome_early.approve_read',
            'gohome_early.approve_manager',
            'gohome_early.approve_hrd',
            'gohome_early.*',
            'reimbursement.approve_read',
            'reimbursement.approve_manager',
            'reimbursement.approve_finance',
            'reimbursement.*',
            'business_trip.approve_read',
            'business_trip.approve_manager',
            'business_trip.approve_hrd',
            'business_trip.*',
            'vehicle_booking.approve_read',
            'vehicle_booking.approve_ga',
            'vehicle_booking.*',
            '*',
        ],
        children: [
            {
                id: 'approvals-leaves',
                label: 'Approval Cuti',
                icon: 'event_available',
                route: '/approvals/leaves',
                permission: [
                    'leave.approve_read',
                    'leave.approve_manager',
                    'leave.approve_hrd',
                    'leave.*',
                    '*',
                ],
            },
            {
                id: 'approvals-overtimes',
                label: 'Approval Lembur',
                icon: 'schedule',
                route: '/approvals/overtimes',
                permission: [
                    'overtime.approve_read',
                    'overtime.approve_manager',
                    'overtime.approve_hrd',
                    'overtime.*',
                    '*',
                ],
            },
            {
                id: 'approvals-swap-day-offs',
                label: 'Approval Tukar Hari Libur',
                icon: 'published_with_changes',
                route: '/approvals/swap-day-offs',
                permission: [
                    'swap_day_off.approve_read',
                    'swap_day_off.approve_manager',
                    'swap_day_off.approve_hrd',
                    'swap_day_off.*',
                    '*',
                ],
            },
            {
                id: 'approvals-gohome-earlys',
                label: 'Approval Pulang Cepat',
                icon: 'house',
                route: '/approvals/gohome-earlys',
                permission: [
                    'gohome_early.approve_read',
                    'gohome_early.approve_manager',
                    'gohome_early.approve_hrd',
                    'gohome_early.*',
                    '*',
                ],
            },
            {
                id: 'approvals-reimbursements',
                label: 'Approval Reimburse',
                icon: 'receipt_long',
                route: '/approvals/reimbursements',
                permission: [
                    'reimbursement.approve_manager',
                    'reimbursement.approve_finance',
                    'reimbursement.*',
                    '*',
                ],
            },
            {
                id: 'approvals-business-trips',
                label: 'Approval Dinas (SPD)',
                icon: 'flight_takeoff',
                route: '/approvals/business-trips',
                permission: [
                    'business_trip.approve_manager',
                    'business_trip.approve_hrd',
                    'business_trip.*',
                    '*',
                ],
            },
            {
                id: 'approvals-vehicle-bookings',
                label: 'Approval Kendaraan',
                icon: 'directions_car',
                route: '/approvals/vehicle-bookings',
                permission: [
                    'vehicle_booking.approve_ga',
                    'vehicle_booking.*',
                    '*',
                ],
            },
        ],
    },
];
